import parse from 'html-react-parser';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { StaticImage } from 'gatsby-plugin-image';

import Button from '../../../components/button/Button';
import ClickableContainer from '../../../components/clickableContainer/ClickableContainer';
import QuotationMark from '../../../assets/icons/quotation_mark.svg';
import Star from '../../../assets/icons/star.svg';

import './reviewsSection.scss';

export default function ReviewsSection(props) {
  const { pretitle, title, subtitle } = props;

  useEffect(() => {
    const carousel = document.querySelector('section.reviews>.carousel');
    carousel.addEventListener('scroll', () => {
      const cardEndPositions = [320, 628, 936, 1244];

      let dotNumber = 0;
      cardEndPositions.forEach((position, i) => {
        if (carousel.scrollLeft + window.innerWidth >= position) {
          dotNumber = i;
        }
      });

      const dots = document.querySelectorAll('section.reviews>.carousel-dots>button');
      dots.forEach((d) => d.classList.remove('dot--active'));
      dots[dotNumber].classList.add('dot--active');
    });
  }, []);

  function testimonialDotClick(index) {
    const carousel = document.querySelector('section.reviews>.carousel');
    const cards = document.querySelectorAll('section.reviews>.carousel>.card');
    carousel.scrollTo(cards[index].offsetLeft - ((window.innerWidth - 292) / 2), 0);
  }

  return (
    <section id="reviews" className="reviews">
      <div className="title-container">
        <p className="overline salmon">{pretitle}</p>
        <h2>{parse(title)}</h2>
        <h6>{subtitle}</h6>
      </div>

      <div className="carousel">
        <ClickableContainer className="card" link="https://g.co/kgs/HU11ac">
          <QuotationMark fill="#FF8795" width="32" />
          <p>
            Dr Masri is an excellent Doctor and sleep treatment specialist. [...]
            <br />
            Dr Masri, listens, explains things in detail and is someone I trust and have very
            confidence in.
          </p>
          <div className="rating">
            <StaticImage className="image" src="../../../images/index/testimonial_user_3.png" alt="" />

            <div className="user">
              <p>A Mac</p>
              <p className="date">Aug, 2023</p>
            </div>

            <div className="stars">
              <p>5.0</p>
              <Star width="24px" />
            </div>
          </div>
        </ClickableContainer>
        <ClickableContainer className="card" link="https://g.co/kgs/dB9J3s">
          <QuotationMark fill="#FF8795" width="32" />
          <p>
            Dawn Fitzgerald took the time to explain the process thoroughly and guided me to
            the best care plan, taking into account my insurance.
          </p>
          <div className="rating">
            <StaticImage className="image" src="../../../images/index/testimonial_user_1.png" alt="" />

            <div className="user">
              <p>Nicholas</p>
              <p className="date">Jun, 2023</p>
            </div>

            <div className="stars">
              <p>5.0</p>
              <Star width="24px" />
            </div>
          </div>
        </ClickableContainer>
        <ClickableContainer className="card" link="https://g.co/kgs/1tdcyM">
          <QuotationMark fill="#FF8795" width="32" />
          <p>
            I had a great experience with Dreem Health and Dr. Fitzgerald. She listened to me
            and cared about my previous health leading up to my visit with Dreem. [...]
          </p>
          <div className="rating">
            <StaticImage className="image" src="../../../images/index/testimonial_user_4.png" alt="" />

            <div className="user">
              <p>Keyanna</p>
              <p className="date">Feb, 2023</p>
            </div>

            <div className="stars">
              <p>5.0</p>
              <Star width="24px" />
            </div>
          </div>
        </ClickableContainer>
        <ClickableContainer className="card" link="https://g.co/kgs/vMKXSQ">
          <QuotationMark fill="#FF8795" width="32" />
          <p>
            Nurse practitioner was on time for the tele-health appointment, answered all of my
            questions, and explained the analysis of my sleep study very well.
          </p>
          <div className="rating">
            <StaticImage className="image" src="../../../images/index/testimonial_user_2.png" alt="" />

            <div className="user">
              <p>Cindy</p>
              <p className="date">Mar, 2023</p>
            </div>

            <div className="stars">
              <p>5.0</p>
              <Star width="24px" />
            </div>
          </div>
        </ClickableContainer>
      </div>
      <div className="carousel-dots">
        <button
          onClick={() => testimonialDotClick(0)}
          type="button"
          className="dot dot--active"
          aria-label="dot"
        />
        <button
          onClick={() => testimonialDotClick(1)}
          type="button"
          className="dot"
          aria-label="dot"
        />
        <button
          onClick={() => testimonialDotClick(2)}
          type="button"
          className="dot"
          aria-label="dot"
        />
        <button
          onClick={() => testimonialDotClick(3)}
          type="button"
          className="dot"
          aria-label="dot"
        />
      </div>
      <Button
        text="Read more reviews"
        displayArrow
        dataAttr="CTA_clicked_testimonials"
        link="https://www.google.com/maps/place/Dreem+Health+Sleep+Clinic/@37.1598825,-124.6028077,6z/data=!4m8!3m7!1s0xcce0b522ca53f8b:0x4b4c6cdadb9310df!8m2!3d37.2691675!4d-119.306607!9m1!1b1!16s%2Fg%2F11trr2pt3d?hl=fr&entry=ttu"
        className="blue"
        target="_blank"
      />
    </section>
  );
}

ReviewsSection.propTypes = {
  pretitle: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
};
